import type { Spa } from '~/core/ts/entity/Spa'

import HeadMetaBuilder from '~/core/ts/util/HeadMetaBuilder'
import { translate } from '~/core/ts/util/translate'

export function getSpaDetailPageMetadata(spa: Spa, url: string): object {
  const spaName = spa.name

  const title = translate({
    es: `Reserva Online en ${spaName} al mejor precio`,
    pt: `Reserva Online em ${spaName} ao melhor preço`,
  })
  const desc = translate({
    es: `Reserva ahora en ${spaName}. Conoce el Spa ${spaName} y reserva online. Descubre todos sus tratamientos y servicios. Disfruta de una experiencia relajante y única.`,
    pt: `Reserve agora em ${spaName}. Conheça o Spa ${spaName} e faça a sua reserva online. Descubra todos os seus tratamentos e serviços. Desfrute de uma experiência relaxante e única.`,
  })

  const builder = HeadMetaBuilder.create()
    .withTitle(title)
    .withMetaTitle(title)
    .withMetaDescription(desc)
    .withTwitterMeta(title, desc)
    .withOpenGraphMeta(title, desc)
    .withLink('canonical', url)

  if (spa.images.length > 0) {
    const imageUrl = spa.images[0].url

    builder
      .withTwitterImage(imageUrl)
      .withOpenGraphImage(imageUrl)
      .withThumbnailImage(imageUrl)
  }

  return builder.get()
}
